import client from './client';
import type { DashboardStats, DashboardResponse } from '@/types/dashboard';
import type { HistoryMessage } from '@/types/chat';

export async function fetchDashboard(refresh = false): Promise<DashboardStats> {
  const { data } = await client.get<DashboardResponse>('/fleet/dashboard', {
    params: refresh ? { refresh: true } : undefined,
  });
  return data.data;
}

export async function fetchHistory(sessionId: string): Promise<HistoryMessage[]> {
  const { data } = await client.post<{ success: boolean; messages: HistoryMessage[] }>('/fleet/history', {
    session_id: sessionId,
  });
  return data.messages ?? [];
}

export async function reportError(
  errorData: Record<string, unknown>
): Promise<void> {
  await client.post('/fleet/report_error', errorData);
}

export async function clearHistory(sessionId: string): Promise<void> {
  await client.post('/history/clear', { session_id: sessionId });
}

export async function deleteMessage(
  sessionId: string,
  messageId: string
): Promise<void> {
  await client.delete('/history/message', {
    params: { session_id: sessionId, message_id: messageId },
  });
}
